<template>
  <AppSection>
    <AppContainer :width="mobile ? 'full' : 'normal'">
      <AppCarousel
        :enabled="mobile"
        :autoplay="2000"
        :breakpoints="{
          280: { itemsToShow: 1.8 },
          320: { itemsToShow: 2.2 },
          380: { itemsToShow: 2.7 },
          430: { itemsToShow: 3 },
          600: { itemsToShow: 4 },
        }"
        :track-padding="1"
        :class="{ 'flex justify-between': !mobile }"
        pause-autoplay-on-hover
        wrap-around
      >
        <Slide v-for="{ src, alt } in images" :key="src">
          <LightBox>
            <AppImg :src :alt edgy />
          </LightBox>
        </Slide>
      </AppCarousel>
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { Slide } from 'vue3-carousel';
import { getTrustingCompanyImage } from '~/helpers/image-maps';

const { mobile } = useBreakpoints();
const { trustingCompanies } = useBranch();
const images = trustingCompanies.map(getTrustingCompanyImage);
</script>

<style scoped>
h2 {
  margin-bottom: var(--space-8);
}
.box {
  height: 80px;
  width: 160px;
  position: relative;
}
.box img {
  max-height: 55%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  max-width: calc(100% - 2 * var(--space-5));
  transform: translateY(-50%);
}

@media (max-width: 850px) {
  h2 {
    margin-bottom: var(--space-7);
    text-align: center;
  }
  .box {
    height: 70px;
    width: 140px;
  }
}
</style>